<template>
    <div v-show="!showMyLoading" class="container cart-container">
        <template v-if="cartData.length">
            <div class="head"></div>
            <div class="body">
                <van-checkbox-group
                    v-model="selectedCurrent"
                    class="l-radio-group l-radio check-box-group"
                >
                    <van-checkbox
                        v-for="item in cartData"
                        :key="item.check_val"
                        :name="item.check_val"
                        class="l-checkbox"
                        :checked-color="themeColor"
                        @click.stop="onCartProductToggleTap(item.check_val,item.selectStatus?false:true)"
                    >
                        <l-card
                            class="goods-item-container1"
                            type="primary"
                            plaintext
                            l-class="card goods-item-container"
                            title
                        >
                            <van-swipe-cell
                                class="slide-con"
                                height="200"
                                width="600"
                                :rightWidth="170"
                            >
                                <div class="slide-left">
                                    <div class="goods-item">
                                        <div class="product-info">
                                            <div class="goods-img">
                                                <v-a
                                                    id-type="cartProduct"
                                                    :data-id="item.id"
                                                    @click.native.stop="nothing"
                                                >
                                                    <img :src="item.thumb_img" mode="widthFix" />
                                                </v-a>
                                            </div>
                                            <div class="right">
                                                <v-a
                                                    id-type="cartProduct"
                                                    :data-id="item.id"
                                                    @click.native.stop="nothing"
                                                >
                                                    <div class="text">{{item.name}}</div>
                                                </v-a>
                                                <div class="spec-container">
                                                    <span class="spec-text">{{item.key_name}}</span>
                                                </div>
                                                <div class="price-num">
                                                    <l-price
                                                        l-class="price"
                                                        unit="￥"
                                                        :count="item.shop_price"
                                                        unit-color="#E93A3E"
                                                        count-color="#E93A3E"
                                                        unit-size="11"
                                                        count-size="14"
                                                        :countBlod="true"
                                                        unit-blod
                                                        :delete="false"
                                                        del-color
                                                    />
                                                    <l-count-selector
                                                        l-symbol-class="fabled"
                                                        l-count-class="count-selector-count"
                                                        l-class="count-selector"
                                                        :min="1"
                                                        :num="item.count"
                                                        :max="99999"
                                                        :step="1"
                                                        :disabled="false"
                                                        :data-key="item.spec_key"
                                                        :data-id="item.id"
                                                        @lintap="onChangeCountTap"
                                                        @click="nothing"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <template slot="right">
                                    <div class="slide-right">
                                        <div :data-id="item.id" :data-key="item.spec_key">喜欢</div>
                                        <div :data-id="item.id" :data-key="item.spec_key">分享</div>
                                        <div
                                            :data-id="item.id"
                                            :data-key="item.spec_key"
                                            @click.stop="deleteTap"
                                        >删除</div>
                                    </div>
                                </template>
                            </van-swipe-cell>
                        </l-card>
                    </van-checkbox>
                </van-checkbox-group>
            </div>
            <div class="bottom">
                <div class="select">
                    <van-checkbox-group v-model="allBtnCurrent">
                        <van-checkbox
                            name="全选"
                            checked-color="#fa671f"
                            @click.stop="onAllSelectToggleTap"
                        >全选</van-checkbox>
                    </van-checkbox-group>
                </div>
                <div class="total-btn">
                    <div class="total">
                        <span>合计</span>
                        <l-price
                            l-class="price"
                            unit="￥"
                            :count="account"
                            unit-color="#E93A3E"
                            count-color="#E93A3E"
                            :unitSize="9"
                            :countSize="16"
                            :countBlod="true"
                            unit-blod
                            :delete="false"
                            del-color
                        />
                    </div>
                    <v-a id-type="cartSubmit" class="submit" @click.native.stop="onSubmitOrderTap">
                        <l-button
                            shape="spuare"
                            class="submit"
                            @lintap="onSubmitOrderTap"
                        >结算（{{selectedTypeCounts}}）</l-button>
                    </v-a>
                </div>
            </div>
            <MyTabbar current="cart"></MyTabbar>
        </template>
        <template v-if="!cartData || cartData.length == 0">
            <l-status-show
                :show="true"
                button-text="去逛逛"
                :image="emptyCartImg"
                describe
                type="cart"
                l-image-class="cart-empty-img"
            />
        </template>
        <Loading :show="showMyLoading" loadingtext="拼命加载中..." />
    </div>
</template>

<script>
import AVue from '../components/my/A.vue'
import CardVue from '../components/lin-ui/Card.vue'
import PriceVue from '../components/lin-ui/Price.vue'
import MyTabbar from '../components/my/MyTabbar.vue'
import MyButton from '../components/my/Button.vue'
import CountSelectorVue from '../components/lin-ui/CountSelector.vue'
import { CommonMixins } from '../components/mixins'
import { add, div, mul } from '../utils/cal'
import { getDataSet, getArrColumn } from '../utils'
import { Cart } from '../models/cart'
import { Token } from '../models/token'
import StatusShowVue from '../components/lin-ui/StatusShow.vue'
import emptyCartImg from '@/assets/images/icon/xian.png'
import Loading from '../components/my/Loading.vue'
import { AgencyModel } from '../models/agency'
const cart = new Cart()
const agency = new AgencyModel()
export default {
    name: 'Cart',
    components: {
        'v-a': AVue,
        'l-card': CardVue,
        'l-price': PriceVue,
        MyTabbar,
        'l-button': MyButton,
        'l-count-selector': CountSelectorVue,
        'l-status-show': StatusShowVue,
        Loading
    },
    mixins: [CommonMixins],
    data() {
        return {
            cartData: [],
            selectedCurrent: [],
            showPage: true,
            allBtnCurrent: [],
            allSelectedCurrent: null,
            selectedTypeCounts: 0,
            account: 0,
            emptyCartImg: emptyCartImg
        }
    },
    computed: {},
    beforeCreate() {},
    async created() {
        await this._loadData()
        const token = new Token()
        token.verify()
    },
    mounted() {},

    methods: {
        showPageNow(isShow = true) {
            this.setData({
                showPage: isShow
            })
        },
        async _loadData() {
            const sign = this.$route.query.sign || '',
                scanPc = this.$route.query.pc || 0
            let cartData = []
            if (scanPc) {
                let res = await cart.getCartDataFromServer(sign)
                if (res.products) {
                    cartData = res.products
                    agency.cacheId(res.shop_id)
                    cart.scanOk(sign)
                }
            } else {
                cartData = cart.getCartDataFromLocal()
            }
            this._getCartGoods(cartData)
            this.setSelectedGoods(cartData)
            this.renderTotalInfo() // 底下总况信息
            // this.showPageNow()

            this.myLoading(0)
        },

        _getCartGoods(cartData) {
            const newData = cartData.map(val => {
                return val
            })
            this.resetCartData(newData)
        },
        /**
         * 重新设置购物车数据并缓存
         * @param {Array} newData
         */
        resetCartData(newData) {
            this.setData({
                cartData: newData
            })
            cart.cache(newData)
        },
        setSelectedGoods(cartData) {
            const selectedGoods = cartData.filter(val => val.selectStatus),
                selectedCurrent = getArrColumn(selectedGoods, 'check_val')
            this.setData({
                selectedCurrent
            })
        },
        isAllSelected() {
            this.setData({
                allBtnCurrent:
                    this.cartData.length == this.selectedTypeCounts
                        ? ['全选']
                        : []
            })
        },
        // 处理购物车商品统计数据（总金额与物品种类数）
        calTotalInfo: function(data) {
            data = data || this.cartData
            var selectedTypeCounts = 0,
                allSelectedCurrent = [],
                account = 0, // 金额
                multi = 100, // 元变分
                num = data.length
            for (var i = 0; i < num; i++) {
                if (data[i].selectStatus) {
                    var price = data[i].shop_price * multi,
                        money = mul(price, data[i].count)
                    account = add(account, money)
                    selectedTypeCounts++
                }
                allSelectedCurrent.push(`${data[i].id}-${data[i].spec_key}`)
            }
            this.setData({
                selectedTypeCounts,
                account: div(account, multi),
                allSelectedCurrent
            })
        },
        renderTotalInfo() {
            this.calTotalInfo()
            this.isAllSelected()
        },
        getProductIndex(id, spec_key) {
            return this.cartData.findIndex(
                value => value.id == id && value.spec_key == spec_key
            )
        },
        // 改变购物车商品的数量
        onChangeCountTap: function(e) {
            const id = e['data-id'],
                spec_key = e['data-key']
            const index = this.getProductIndex(id, spec_key),
                changeType = e.type,
                count = e.count
            switch (changeType) {
                case 'add':
                    cart.addCount(id, spec_key)
                    break
                case 'reduce':
                    cart.cutCount(id, spec_key)
                    break
                case 'blur':
                default:
                    if (this.cartData[index].count == 0) return
                    break
            }
            this.cartData[index].count = count
            this.resetCartData(this.cartData)
            this.calTotalInfo()
        },
        onCartProductToggleTap: function(val, current) {
            const index = this.cartData.findIndex(
                value => `${value.id}-${value.spec_key}` == val
            )
            if (index == -1) return
            this.cartData[index].selectStatus = current
            this.resetCartData(this.cartData)
            this.renderTotalInfo()
        },

        /* 删除 */
        deleteTap: function(e) {
            const id = getDataSet(e, 'id'),
                spec_key = getDataSet(e, 'key'),
                index = this.cartData.findIndex(
                    value => value.id == id && value.spec_key == spec_key
                )
            if (index == -1) return
            cart.delete(id, spec_key)
            this.cartData.splice(index, 1)
            this.resetCartData(this.cartData)
            this.calTotalInfo()
        },

        // 全选
        onAllSelectToggleTap: function(e) {
            const current = !Array.from(this.allBtnCurrent).includes('全选')

            this.setData({
                selectedCurrent: current ? this.allSelectedCurrent : []
                // allBtnCurrent: current ? ['全选'] : []
            })
            let cartData = this.cartData.map(item => {
                item.selectStatus = current
                return item
            })
            this.resetCartData(cartData)
            this.calTotalInfo()
        },
        // 结算
        onSubmitOrderTap: function(e) {
            if (this.selectedTypeCounts > 0)
                // wx.navigateTo({
                //     url: '/pages/order/confirm/confirm?account=' + this.account
                // })
                this.toPage('/order_confirm')
            else {
                this.dialog('温馨提示', '请选择您要买的商品!')
            }
        }
    }
}
</script>
<style lang='stylus' >
.cart-container
    padding-bottom: 100px
    position: relative
    .head
        position: absolute
        width: 100%
        height: 40px
        background-color: #FA671F
        z-index: 1
    .body
        position: relative
        z-index: 2
    .goods-item
        display: flex
        align-items: center
        .product-info
            display: flex
            .goods-img
                width: 60px !important
                padding-right: 10px
            .right
                flex: 1
                width: 238px
                .text
                    width: 100%
            .spec
                width: auto
                display: inline-flex
                align-items: center
            .spec-text
                color: #A2A2A2
            .price-num
                margin-top: 5px
                display: flex
                justify-content: space-between
    .bottom
        position: fixed
        bottom: 55px
        width: 100%
        display: flex
        align-items: center
        justify-content: space-between
        background: #fff
        padding-left: 15px
        z-index: 3
        .total-btn
            display: flex
            .total
                min-width: 90px
                align-items: center
                display: flex
.count-selector
    border: 1px solid #EFEFEF
    border-radius: 5px
    z-index: 5
.fabled
    background-color: #fff !important
    color: #FA671F !important
    display: inline-flex !important
    justify-content: center
    align-items: center
    padding-bottom: 4px
.count-selector-count
    background-color: #fff !important
    color: #000 !important
    margin: 0 !important
    border-left: 1px solid #EFEFEF
    border-right: 1px solid #EFEFEF
.card
    padding-right: 5px !important
.slide-con
    .slide-left
        background-color: #fff
        height: auto
        width: 100%
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        box-sizing: border-box
        .left-con
            display: flex
            flex-direction: column
    .slide-right
        height: 100%
        display: flex
        direction: row
        align-items: center
        background: #FA671F
        opacity: 0.9
        color: #fff
        font-size: 14px
        div
            height: 100%
            flex: 1
            display: inline-flex
            align-items: center
            justify-content: center
.l-checkbox
    padding-bottom: 10px
    margin-right: 0
.van-checkbox
    min-height: 18px
.van-checkbox__icon
    width: 18px
    height: 18px
    font-size: 18px
.l-checkbox
    display: flex
    width: auto
    align-items: center
.l-radio
    margin-right: 0
    padding: 0 15px
.goods-item-container
    padding: 10px 10px !important
    width: auto !important
.cart-empty-img
    width: 275px !important
    height: 250px !important
.check-box-group
    margin-top: 15px
.van-swipe-cell__right
    width: 170px
.van-swipe-cell__wrapper
    min-height: 60px
.cart-empty-img
    width: 272.5px !important
    height: 250px !important
</style>
